var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import isEqual from 'lodash/isEqual';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import isValid from 'date-fns/isValid';
import Button from '../button';
import Popover from '../popover';
import Icon from '../icon';
import TimeRangePicker from '../time-range-picker';
import Theme from '../theme.config';
import { Styled } from './style';
var MultilineTimeRangePicker = /** @class */ (function (_super) {
    __extends(MultilineTimeRangePicker, _super);
    function MultilineTimeRangePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.getInitialState = function () {
            if (_this.props.values.length) {
                return {
                    timeRangeList: _this.props.values,
                    isDefaultValues: false,
                };
            }
            else {
                return {
                    timeRangeList: _this.props.defaultValues ? _this.props.defaultValues : [],
                    isDefaultValues: true,
                };
            }
        };
        _this.addTimeRange = function () {
            var _a = _this.props, onChange = _a.onChange, defaultValues = _a.defaultValues;
            _this.setState(function (prevState) { return (__assign(__assign({}, prevState), { timeRangeList: __spreadArrays(prevState.timeRangeList, [
                    {
                        start: '00:00:00',
                        end: '24:00:00',
                    },
                ]) })); }, onChange
                ? function () {
                    if (!isEqual(defaultValues, _this.state.timeRangeList)) {
                        onChange(_this.state.timeRangeList);
                    }
                }
                : undefined);
        };
        _this.removeInput = function (id) {
            _this.setState(function (prevState) { return (__assign(__assign({}, prevState), { timeRangeList: prevState.timeRangeList.filter(function (_, index) { return index !== id; }) })); }, function () { return _this.props.onChange && _this.props.onChange(_this.state.timeRangeList); });
        };
        _this.handleTimeRangePickerChange = function (value, index) {
            var _a = _this.props, onChange = _a.onChange, defaultValues = _a.defaultValues;
            _this.setState(function (prevState) { return (__assign(__assign({}, prevState), { timeRangeList: __spreadArrays(prevState.timeRangeList.slice(0, index), [
                    value
                ], prevState.timeRangeList.slice(index + 1)) })); }, onChange
                ? function () {
                    if (!isEqual(defaultValues, _this.state.timeRangeList)) {
                        onChange(_this.state.timeRangeList);
                    }
                }
                : undefined);
        };
        _this.state = _this.getInitialState();
        return _this;
    }
    MultilineTimeRangePicker.prototype.render = function () {
        var _this = this;
        var timeRangeList = this.state.timeRangeList;
        return (React.createElement(Styled, { disabled: this.props.disabled },
            timeRangeList.map(function (timeRange, index) {
                var _a, _b, _c, _d, _e;
                // Temp date for Safari support
                var isStartTimeOver24h = ((_a = timeRange.start) === null || _a === void 0 ? void 0 : _a.startsWith('24')) && !isValid(new Date('2000-01-01T' + timeRange.start.trim()));
                var isEndTimeOver24h = ((_b = timeRange.end) === null || _b === void 0 ? void 0 : _b.startsWith('24')) && !isValid(new Date('2000-01-01T' + timeRange.end.trim()));
                var isOverlap = _this.props.overlapIndexes !== undefined ? (_c = _this.props.overlapIndexes) === null || _c === void 0 ? void 0 : _c.some(function (item) { return item === index; }) : false;
                var transformStartTime = isStartTimeOver24h ? (_d = timeRange.start) === null || _d === void 0 ? void 0 : _d.replace('24', '00') : timeRange.start;
                var transformEndTime = isEndTimeOver24h ? (_e = timeRange.end) === null || _e === void 0 ? void 0 : _e.replace('24', '00') : timeRange.end;
                return (React.createElement("div", { key: index, className: "item-row" },
                    React.createElement(TimeRangePicker, { key: index, showSecond: true, locale: _this.props.locale, compact: true, value: { start: transformStartTime, end: transformEndTime }, onChange: function (value) { return _this.handleTimeRangePickerChange(value, index); } }),
                    React.createElement(Button, { onClick: function () {
                            _this.removeInput(index);
                        }, tabIndex: "-1", transparent: true },
                        React.createElement(Icon, { name: "remove-fill" })),
                    isOverlap &&
                        React.createElement(Popover, { trigger: React.createElement(Icon, { name: "warning", className: "icon-warning" }), content: "Conflicts with another time", position: "top center", inverted: true })));
            }),
            !this.props.disabled &&
                React.createElement(Button, { onClick: this.addTimeRange, mini: true, className: timeRangeList.length > 0 ? 'btn-add' : 'btn-add allday' }, timeRangeList.length > 0 ? (React.createElement(React.Fragment, null,
                    React.createElement(Icon, { name: "plus-fill" }),
                    React.createElement(FormattedMessage, { id: "ui_component.multiline_time_input.add", defaultMessage: "Add" }))) : (React.createElement(React.Fragment, null,
                    React.createElement(FormattedMessage, { id: "ui_component.multiline_time_input.all_day", defaultMessage: "All day" }),
                    React.createElement(Icon, { name: "edit", color: Theme.color.grey }))))));
    };
    MultilineTimeRangePicker.getDerivedStateFromProps = function (nextProps, prevState) {
        if (prevState.timeRangeList === nextProps.values) {
            return {
                timeRangeList: nextProps.values,
                isDefaultValues: false,
            };
        }
        return null;
    };
    return MultilineTimeRangePicker;
}(React.Component));
export default MultilineTimeRangePicker;
//# sourceMappingURL=index.js.map